export default "__VITE_ASSET__CT7n$CSL__"